var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useIntl } from 'react-intl';
import { useStateService } from '@/shared/services/StateService';
import messages from '../generalSettingsMessages';
var LegalEntityManagedNotice = function (_a) {
    var legalEntityId = _a.legalEntityId, legalEntityName = _a.legalEntityName;
    var intl = useIntl();
    var stateService = useStateService();
    return (_jsxs("span", __assign({ className: "form-control-static" }, { children: [_jsx("i", { className: "fa fa-info-circle margin5R text-muted" }), intl.formatMessage(messages.ManagedByLegalEntity, { name: legalEntityName }), _jsx("a", __assign({ className: "clickable margin5L", onClick: function () { return stateService.gotoState('settings.legalEntities', { id: legalEntityId }); }, title: intl.formatMessage(messages.OpenLegalEntity) }, { children: _jsx("i", { className: "fa fa-external-link" }) }))] })));
};
export default LegalEntityManagedNotice;
